/**
 * @desc 导出-sku库存变动记录
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(params: API.stock.stockSku.exportListStockSkuRecord.Params, options?: any) {
  return updateResponse(
    http(URL + `/stock/sku/export/recordList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
